import { jsx as r } from "react/jsx-runtime";
import { NeuAlertContextual as n } from "@hcahealthcaredpx/neutron-react";
import { u as c } from "../../chunks/useNetworkStatus.B65eRjoK.js";
const u = ({ fields: t, rendering: o }) => {
  var e;
  const { isOnline: a } = c();
  return a ? null : /* @__PURE__ */ r(
    "div",
    {
      className: "d-print-none d-flex justify-content-center",
      "data-test-id": o == null ? void 0 : o.componentName,
      children: /* @__PURE__ */ r("div", { className: "container p-0", children: /* @__PURE__ */ r(n, { kind: "error", className: "py-2", children: ((e = t == null ? void 0 : t.alertText) == null ? void 0 : e.value) ?? "" }) })
    }
  );
};
export {
  u as MhoTimeoutErrorAlert
};
